//Libraries
import React from 'react';
import { Step, Stepper } from 'react-form-stepper';

import "./vehicle-stepper.component.scss"

const VehicleStepperComponent = (props) => {

    const {
        //Functions
        onStepper = () => null,
        //Variables
        dataStepper,
        locationStepper,
    } = props;

    return (
        <div className='grid-x small-12 vehicle-stepper__content'>
            <Stepper
                activeStep={locationStepper}
                connectorStateColors={locationStepper ? true : false}
                className="grid-x vehicle-stepper__steppers"
            >
                {dataStepper.map((sections, index) => (
                    <Step
                        key={index}
                        label={sections?.label}
                        onClick={() => onStepper(index)}
                        className={`vehicle-stepper__step ${index <= locationStepper
                            ? "vehicle-stepper__step--active"
                            : "vehicle-stepper__step--inactive"
                            } ${index < locationStepper
                                ? "vehicle-stepper__button-active"
                                : ""}
                        `}
                    />
                ))}
            </Stepper>
        </div>
    )
}

export default VehicleStepperComponent;